export default __webpack_public_path__ + "static/media/Group 1693@2x.399351ec.png";